import { Link } from "react-router-dom";
import PublicFooter from "@/components/PublicFooter";

export default function LegalLayout({ title, children }) {
  return (
    <div className="mp-legal">
      <header className="mp-legal-bar">
        <Link to="/" className="mp-legal-brand">
          <span className="mpd-mark">M</span>
          <strong>MinutePay</strong>
        </Link>
        <nav className="mp-legal-nav">
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/refunds">Refunds</Link>
          <Link to="/login">Sign in</Link>
        </nav>
      </header>
      <article className="mp-legal-card">
        <p className="mp-kicker">MinutePay</p>
        <h1>{title}</h1>
        <p className="mp-legal-updated">Last updated: September 2026</p>
        <div className="mp-legal-body">{children}</div>
      </article>
      <PublicFooter />
    </div>
  );
}
